var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#59d2d9",
    d: "M11-.2L22.085 19H-.085z"
  })));
}
export default __webpack_public_path__ + "static/svg/multikills/triple.svg";
export { SvgTriple as ReactComponent };